import { render, staticRenderFns } from "./MarkerPopup.vue?vue&type=template&id=0cf1a680&scoped=true"
import script from "./MarkerPopup.vue?vue&type=script&lang=js"
export * from "./MarkerPopup.vue?vue&type=script&lang=js"
import style0 from "./MarkerPopup.vue?vue&type=style&index=0&id=0cf1a680&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1a680",
  null
  
)

export default component.exports